// extracted by mini-css-extract-plugin
export var component = "Faq-module--component--kDLQl";
export var question = "Faq-module--question--UGe9W";
export var answer = "Faq-module--answer--4oPlR";
export var button = "Faq-module--button--EeXqk";
export var buttonActive = "Faq-module--buttonActive--K10nC";